import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CoreStore } from './core/store/core.store';

export const canActivateApp: CanActivateFn = () => {
  const store = inject(CoreStore);

  const sessionExists = store.sessionExists();
  if (sessionExists === null) {
    store.checkSessionExists();
  }

  return true;
};
